import * as React from "react";

const IconReceitaBX = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 26}
    height={props.height ?? 17}
    fill="none"
    viewBox="0 0 26 17"
    {...props}
  >
    <path
      fill="#fff"
      d="M11.35.487 9.812.962l.768.254c1.163.39 2.25.813 2.206.855-.022.021-.834-.01-1.789-.074a67 67 0 0 0-2.7-.105h-.944l-2.008.961C3.82 3.582.22 5.463 0 5.642c-.044.042 2.557 1.88 2.667 1.88.065 0 .9-.475 1.865-1.056 2.371-1.426 3.952-2.282 6.355-3.433l2.03-.962.583.243c.845.349 3.435 1.606 4.203 2.039.362.2.67.36.68.349.044-.043.363-2.176.363-2.43 0-.275-.461-.496-2.58-1.257C15.51.783 12.876-.031 12.876.001c0 0-.692.222-1.526.486"
    ></path>
    <path
      fill="#fff"
      d="M12.052 3.128c-1.372.21-2.415 1.077-2.261 1.87.066.348.57.887 1.054 1.12 1.393.696 3.731.485 4.72-.413.416-.38.504-.591.438-1.109-.11-.982-2.162-1.743-3.951-1.468M20.217 3.857c-.647.316-1.7.887-2.337 1.257-1.482.855-4.654 2.936-4.698 3.074-.022.063.351.169.867.242 1.065.148 5.686 1.025 6.212 1.162.352.106.406.074 1.734-1.003A81 81 0 0 1 24.64 6.57c1.12-.803 1.23-.908 1.054-1.024-.395-.264-2.733-1.521-3.512-1.902l-.78-.37zM7.365 4.976c-.165.2-1.098 1.838-1.833 3.233l-.637 1.183.582.507a200 200 0 0 1 5.4 4.806l2.052 1.89 1.712-1.562c.933-.867 2.042-1.88 2.459-2.24.428-.37.768-.718.768-.76 0-.117-1.152-1.014-3.018-2.377-.78-.57-1.548-1.12-1.701-1.236-1.12-.803-5.159-3.391-5.521-3.528-.088-.032-.209.01-.263.084"
    ></path>
  </svg>
);

export default IconReceitaBX;
